module.exports = __webpack_public_path__ + "static/media/southpole.839303ae.jpg";